import { render, staticRenderFns } from "./form-input.vue?vue&type=template&id=2a0d9a6b"
import script from "./form-input.vue?vue&type=script&lang=js"
export * from "./form-input.vue?vue&type=script&lang=js"
import style0 from "./form-input.vue?vue&type=style&index=0&id=2a0d9a6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports